import { useTranslation } from 'react-i18next';

import Hr from '../../components/Style/hr';
import DescriptionSplit from '../../components/Description/description-split';
import TitleQuotation from '../../components/title-quotation';
import Link from '../../components/Links/link';
import Button from '../../components/Buttons/button';

export default function PaidStepServices() {
    const { t } = useTranslation();

    return (
        <div className='px-4 md:px-0 mb-6'>
            <TitleQuotation title={t('pageServices.paid.welcomeMessage')} description={t('pageServices.paid.description')} step="4" />
            <Hr />
            <DescriptionSplit description={t('pageServices.paid.descriptionSplit')} opacity='100' className='text-secondary' />

            <div className='mt-12 text-center'>
                <Link link={"/"} disableHoverEffect={true}>
                    <Button text={t('pageServices.paid.button')} />
                </Link>
            </div>
        </div>
    );
}